/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { contactsCreateContactFromNumbersListGet } from '../fn/contacts/contacts-create-contact-from-numbers-list-get';
import { ContactsCreateContactFromNumbersListGet$Params } from '../fn/contacts/contacts-create-contact-from-numbers-list-get';
import { contactsCreateContactFromNumbersListPost } from '../fn/contacts/contacts-create-contact-from-numbers-list-post';
import { ContactsCreateContactFromNumbersListPost$Params } from '../fn/contacts/contacts-create-contact-from-numbers-list-post';
import { contactsCreateContactsFromFileGet } from '../fn/contacts/contacts-create-contacts-from-file-get';
import { ContactsCreateContactsFromFileGet$Params } from '../fn/contacts/contacts-create-contacts-from-file-get';
import { contactsCreateContactsFromFilePost } from '../fn/contacts/contacts-create-contacts-from-file-post';
import { ContactsCreateContactsFromFilePost$Params } from '../fn/contacts/contacts-create-contacts-from-file-post';
import { contactsCreateGet } from '../fn/contacts/contacts-create-get';
import { ContactsCreateGet$Params } from '../fn/contacts/contacts-create-get';
import { contactsCreatePost } from '../fn/contacts/contacts-create-post';
import { ContactsCreatePost$Params } from '../fn/contacts/contacts-create-post';
import { contactsDelete } from '../fn/contacts/contacts-delete';
import { ContactsDelete$Params } from '../fn/contacts/contacts-delete';
import { contactsDeleteAllContactsByPhonebookId } from '../fn/contacts/contacts-delete-all-contacts-by-phonebook-id';
import { ContactsDeleteAllContactsByPhonebookId$Params } from '../fn/contacts/contacts-delete-all-contacts-by-phonebook-id';
import { contactsDeleteContactFromAllPhonebooks } from '../fn/contacts/contacts-delete-contact-from-all-phonebooks';
import { ContactsDeleteContactFromAllPhonebooks$Params } from '../fn/contacts/contacts-delete-contact-from-all-phonebooks';
import { contactsDeleteContacts } from '../fn/contacts/contacts-delete-contacts';
import { ContactsDeleteContacts$Params } from '../fn/contacts/contacts-delete-contacts';
import { contactsGetContactColumnNames } from '../fn/contacts/contacts-get-contact-column-names';
import { ContactsGetContactColumnNames$Params } from '../fn/contacts/contacts-get-contact-column-names';
import { contactsGetContactsAuditWithPagination } from '../fn/contacts/contacts-get-contacts-audit-with-pagination';
import { ContactsGetContactsAuditWithPagination$Params } from '../fn/contacts/contacts-get-contacts-audit-with-pagination';
import { contactsGetContactsByCellPhone } from '../fn/contacts/contacts-get-contacts-by-cell-phone';
import { ContactsGetContactsByCellPhone$Params } from '../fn/contacts/contacts-get-contacts-by-cell-phone';
import { contactsGetContactsWithPagination } from '../fn/contacts/contacts-get-contacts-with-pagination';
import { ContactsGetContactsWithPagination$Params } from '../fn/contacts/contacts-get-contacts-with-pagination';
import { contactsUpdateContacts } from '../fn/contacts/contacts-update-contacts';
import { ContactsUpdateContacts$Params } from '../fn/contacts/contacts-update-contacts';
import { contactsUpdateGet } from '../fn/contacts/contacts-update-get';
import { ContactsUpdateGet$Params } from '../fn/contacts/contacts-update-get';
import { contactsUpdatePut } from '../fn/contacts/contacts-update-put';
import { ContactsUpdatePut$Params } from '../fn/contacts/contacts-update-put';
import { contactsUploadContactsFile } from '../fn/contacts/contacts-upload-contacts-file';
import { ContactsUploadContactsFile$Params } from '../fn/contacts/contacts-upload-contacts-file';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfContactByIdDto } from '../models/custom-result-of-contact-by-id-dto';
import { CustomResultOfListOfContactNameDto } from '../models/custom-result-of-list-of-contact-name-dto';
import { CustomResultOfPaginatedListOfContactsByCellPhoneDto } from '../models/custom-result-of-paginated-list-of-contacts-by-cell-phone-dto';
import { CustomResultOfPaginatedListOfContactsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-contacts-with-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ContactsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactsCreateGet()` */
  static readonly ContactsCreateGetPath = '/Contacts/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsCreateGet$Response(params?: ContactsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return contactsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsCreateGet(params?: ContactsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.contactsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `contactsCreatePost()` */
  static readonly ContactsCreatePostPath = '/Contacts/Create';

  /**
   * Create Contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsCreatePost$Response(params: ContactsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsCreatePost(params: ContactsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsCreateContactFromNumbersListGet()` */
  static readonly ContactsCreateContactFromNumbersListGetPath = '/Contacts/CreateContactFromNumbersList';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsCreateContactFromNumbersListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsCreateContactFromNumbersListGet$Response(params?: ContactsCreateContactFromNumbersListGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return contactsCreateContactFromNumbersListGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsCreateContactFromNumbersListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsCreateContactFromNumbersListGet(params?: ContactsCreateContactFromNumbersListGet$Params, context?: HttpContext): Observable<Blob> {
    return this.contactsCreateContactFromNumbersListGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `contactsCreateContactFromNumbersListPost()` */
  static readonly ContactsCreateContactFromNumbersListPostPath = '/Contacts/CreateContactFromNumbersList';

  /**
   * Create Contact From Numbers List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsCreateContactFromNumbersListPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsCreateContactFromNumbersListPost$Response(params: ContactsCreateContactFromNumbersListPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsCreateContactFromNumbersListPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Contact From Numbers List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsCreateContactFromNumbersListPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsCreateContactFromNumbersListPost(params: ContactsCreateContactFromNumbersListPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsCreateContactFromNumbersListPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsCreateContactsFromFileGet()` */
  static readonly ContactsCreateContactsFromFileGetPath = '/Contacts/CreateContactsFromFile';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsCreateContactsFromFileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsCreateContactsFromFileGet$Response(params?: ContactsCreateContactsFromFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return contactsCreateContactsFromFileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsCreateContactsFromFileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsCreateContactsFromFileGet(params?: ContactsCreateContactsFromFileGet$Params, context?: HttpContext): Observable<Blob> {
    return this.contactsCreateContactsFromFileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `contactsCreateContactsFromFilePost()` */
  static readonly ContactsCreateContactsFromFilePostPath = '/Contacts/CreateContactsFromFile';

  /**
   * Create Contact From List By Json LzString.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsCreateContactsFromFilePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsCreateContactsFromFilePost$Response(params: ContactsCreateContactsFromFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsCreateContactsFromFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Contact From List By Json LzString.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsCreateContactsFromFilePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsCreateContactsFromFilePost(params: ContactsCreateContactsFromFilePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsCreateContactsFromFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsDelete()` */
  static readonly ContactsDeletePath = '/Contacts';

  /**
   * Delete Contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsDelete$Response(params: ContactsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsDelete(params: ContactsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsUpdateGet()` */
  static readonly ContactsUpdateGetPath = '/Contacts/Update';

  /**
   * Get contact by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsUpdateGet$Response(params?: ContactsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfContactByIdDto>> {
    return contactsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get contact by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsUpdateGet(params?: ContactsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfContactByIdDto> {
    return this.contactsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfContactByIdDto>): CustomResultOfContactByIdDto => r.body)
    );
  }

  /** Path part for operation `contactsUpdatePut()` */
  static readonly ContactsUpdatePutPath = '/Contacts/Update';

  /**
   * Update Contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsUpdatePut$Response(params: ContactsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsUpdatePut(params: ContactsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsGetContactsWithPagination()` */
  static readonly ContactsGetContactsWithPaginationPath = '/Contacts/GetContactsWithPagination';

  /**
   * For each user get Contacts with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsGetContactsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsGetContactsWithPagination$Response(params: ContactsGetContactsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfContactsWithPaginationDto>> {
    return contactsGetContactsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get Contacts with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsGetContactsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsGetContactsWithPagination(params: ContactsGetContactsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfContactsWithPaginationDto> {
    return this.contactsGetContactsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfContactsWithPaginationDto>): CustomResultOfPaginatedListOfContactsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `contactsGetContactsAuditWithPagination()` */
  static readonly ContactsGetContactsAuditWithPaginationPath = '/Contacts/GetContactsAuditWithPagination';

  /**
   * Get Contacts Audit With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsGetContactsAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsGetContactsAuditWithPagination$Response(params: ContactsGetContactsAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return contactsGetContactsAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Contacts Audit With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsGetContactsAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsGetContactsAuditWithPagination(params: ContactsGetContactsAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.contactsGetContactsAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `contactsGetContactColumnNames()` */
  static readonly ContactsGetContactColumnNamesPath = '/Contacts/GetContactColumnNames';

  /**
   * Get Contact Column Names.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsGetContactColumnNames()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsGetContactColumnNames$Response(params?: ContactsGetContactColumnNames$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfContactNameDto>> {
    return contactsGetContactColumnNames(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Contact Column Names.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsGetContactColumnNames$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsGetContactColumnNames(params?: ContactsGetContactColumnNames$Params, context?: HttpContext): Observable<CustomResultOfListOfContactNameDto> {
    return this.contactsGetContactColumnNames$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfContactNameDto>): CustomResultOfListOfContactNameDto => r.body)
    );
  }

  /** Path part for operation `contactsDeleteAllContactsByPhonebookId()` */
  static readonly ContactsDeleteAllContactsByPhonebookIdPath = '/Contacts/DeleteAllContactsByPhonebookId';

  /**
   * Delete All Contacts By PhonebookId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsDeleteAllContactsByPhonebookId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsDeleteAllContactsByPhonebookId$Response(params?: ContactsDeleteAllContactsByPhonebookId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsDeleteAllContactsByPhonebookId(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete All Contacts By PhonebookId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsDeleteAllContactsByPhonebookId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsDeleteAllContactsByPhonebookId(params?: ContactsDeleteAllContactsByPhonebookId$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsDeleteAllContactsByPhonebookId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsDeleteContacts()` */
  static readonly ContactsDeleteContactsPath = '/Contacts/DeleteContacts';

  /**
   * Delete Contacts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsDeleteContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsDeleteContacts$Response(params: ContactsDeleteContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsDeleteContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Contacts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsDeleteContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsDeleteContacts(params: ContactsDeleteContacts$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsDeleteContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsDeleteContactFromAllPhonebooks()` */
  static readonly ContactsDeleteContactFromAllPhonebooksPath = '/Contacts/DeleteContactFromAllPhonebooks';

  /**
   * Delete Contact From All Phonebooks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsDeleteContactFromAllPhonebooks()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsDeleteContactFromAllPhonebooks$Response(params: ContactsDeleteContactFromAllPhonebooks$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsDeleteContactFromAllPhonebooks(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Contact From All Phonebooks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsDeleteContactFromAllPhonebooks$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsDeleteContactFromAllPhonebooks(params: ContactsDeleteContactFromAllPhonebooks$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsDeleteContactFromAllPhonebooks$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsUploadContactsFile()` */
  static readonly ContactsUploadContactsFilePath = '/Contacts/UploadContactsFile';

  /**
   * آپلود فایل اکسل برای ثبت گیرندگان از فایل اکسل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsUploadContactsFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  contactsUploadContactsFile$Response(params?: ContactsUploadContactsFile$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsUploadContactsFile(this.http, this.rootUrl, params, context);
  }

  /**
   * آپلود فایل اکسل برای ثبت گیرندگان از فایل اکسل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsUploadContactsFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  contactsUploadContactsFile(params?: ContactsUploadContactsFile$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsUploadContactsFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsUpdateContacts()` */
  static readonly ContactsUpdateContactsPath = '/Contacts/UpdateContacts';

  /**
   * ویرایش چند مخاطب.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsUpdateContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsUpdateContacts$Response(params: ContactsUpdateContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactsUpdateContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش چند مخاطب.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsUpdateContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsUpdateContacts(params: ContactsUpdateContacts$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactsUpdateContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactsGetContactsByCellPhone()` */
  static readonly ContactsGetContactsByCellPhonePath = '/Contacts/GetContactsByCellPhone';

  /**
   * دریافت مخاطبین قابل مشاهده کاربر فعلی بر اساس شماره تلفن در همه دفترتلفن ها با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsGetContactsByCellPhone()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsGetContactsByCellPhone$Response(params: ContactsGetContactsByCellPhone$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfContactsByCellPhoneDto>> {
    return contactsGetContactsByCellPhone(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت مخاطبین قابل مشاهده کاربر فعلی بر اساس شماره تلفن در همه دفترتلفن ها با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsGetContactsByCellPhone$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsGetContactsByCellPhone(params: ContactsGetContactsByCellPhone$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfContactsByCellPhoneDto> {
    return this.contactsGetContactsByCellPhone$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfContactsByCellPhoneDto>): CustomResultOfPaginatedListOfContactsByCellPhoneDto => r.body)
    );
  }

}
